import { __extends } from "tslib";
import { TextEvent } from './TextEvent';
var DataEvent = /** @class */ (function (_super) {
    __extends(DataEvent, _super);
    function DataEvent(type, bubbles, cancelable, data) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (data === void 0) { data = ''; }
        return _super.call(this, type, bubbles, cancelable, data) || this;
    }
    DataEvent.classInitializer = null;
    DataEvent.classSymbols = null;
    DataEvent.instanceSymbols = null;
    // JS -> AS Bindings
    DataEvent.DATA = 'data';
    DataEvent.UPLOAD_COMPLETE_DATA = 'uploadCompleteData';
    return DataEvent;
}(TextEvent));
export { DataEvent };
